import IConstructionOutput from "../IConstructionOutput";

export default (construction: IConstructionOutput) => {
  const d = new FormData();
  d.append("construction[id]", construction.id);
  d.append(
    "construction[serviceTaskTypeId]",
    String(construction.serviceTaskTypeId)
  );
  d.append("construction[name]", construction.name);
  d.append("construction[shortName]", construction.shortName);

  return d;
};
